import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import {
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Button,
  Typography,
  FormControlLabel,
  Snackbar,
  Backdrop,
  DialogContent,
  ListItemText,
  ListItem,
  List,
  CardHeader,
  IconButton,
  Tooltip,
  Breadcrumbs,
  Link,
} from '@material-ui/core';
import Page from 'src/components/Page';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from 'react-i18next';
import SearchBar from 'material-ui-search-bar';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
// import WorkOrderDetailPage from 'src/views/Operation/WorkOrderDetail';
import ExcelExport from 'src/components/CustomerFeedbackExcelExport';
import { sc } from 'src/utils/Common';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  cardscontent: {
    minHeight: 300,
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    maxHeight: 630,
  },
}));


function ServicePartnerContact() {
  const classes = useStyles();
  const { t } = useTranslation('JobControl');
  const dispatch = useDispatch();
  // const serviceShopControl = useSelector((state) => state.jobControl.ServiceShopControl);
  // const jobOrderStatus = useSelector((state) => state.jobControl.JobOrderStatus);
  // const JobOrderLogicStatus = useSelector((state) => state.jobControl.JobOrderLogicStatus);
  // const rejectReason = useSelector((state) => state.jobControl.RejectReason);
  // const regionServiceControl = useSelector((state) => state.serviceShop.RegionServiceControl);
  // const subServiceShopControl = useSelector((state) => state.jobControl.ServiceShopControl);
  // const issueListSelector = useSelector((state) => state.issue.Issues);
  // const caseStatusListSelector = useSelector((state) => state.jobControl.CaseStatusList);

  const SessionUser = getUser();

 

  const [ServicePartnerContact, setServicePartnerContact] = useState([]);
  const [workOrderId, setWorkOrderId] = useState(0);
  const [workCaseId, setWorkCaseId] = useState(0);
  const [singleWorkOrderId, setSingleWorkOrderId] = useState(0);
  const [StatusLogicData, setStatusLogicData] = useState([]);
  const [reasonData, setReasonData] = useState([]);
  const [statusId, setStatusId] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [Loading, setLoading] = useState(false);
  const [PopUp, setPopUp] = useState(false);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [workOrderPopUp, setWorkOrderPopUp] = useState(false);
  const [checkedWorkCaseId, setCheckedWorkCaseId] = useState([])
  const [regionList, setRegionList] = useState([]);
  const [regionSelected, setRegionSelected] = useState('');
  const [subServiceShopList, setSubServiceShopList] = useState([]);
  const [serviceShopSelected, setServiceShopSelected] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [rejectDescription, setRejectDescription] = useState('');
  const [SnackbarOpen, setSnackbarOpen] = useState(false);
  const [issueList, setIssueList] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState();
  const [caseStatusList, setCaseStatusList] = useState([]);
  const [caseStatusRuleList, setCaseStatusRuleList] = useState([]);
  const [selectedCaseStatus, setSelectedCaseStatus] = useState();
  const [workCaseFeedBacks, setWorkCaseFeedBacks] = useState([]);
  const [statusRuleData, setStatusRuleData] = useState([]);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  //SearchBar
  const [initialRows, setinitialRows] = useState([]);
  const [searched, setSearched] = useState('');

  const today = moment().format('DD-MM-YYYY');
  const oneYearAgo = moment().subtract(1, 'years').format('DD-MM-YYYY');
  const [Required, setRequired] = useState(false);
  const [RequiredForSearch, setRequiredForSearch] = useState(false);

   

  // const SaveIssue = (ids) => {
  //   if (!rejectDescription || !changeStatus) {
  //     setRequired(true);
  //     return
  //   }



  //   setPopUp(false);
  //   setSinglePopUp(false);
  //   confirmAlert({
  //     message: t('lblConfirm'),
  //     buttons: [
  //       {
  //         label: t('lblYes'),
  //         onClick: () => handleSaveIssue(ids)
  //       },
  //       {
  //         label: t('lblNo'),
  //         onClick: () => {
  //         }
  //       }
  //     ]
  //   });
  // };
  async function GetServiceShopByTenant() {
    setServicePartnerContact([]);
    setLoading(true);
        // const temp = [selectedIssue?.Id || 0, selectedCaseStatus?.Id || 0, oneYearAgo.toString(), today.toString()];
        var requestStr = '/GetServiceShopByTenant'
        axios
          .get(requestStr)
          .then(response => {
            const Deger = response.data;
            if (Deger.length > 0) {
              setServicePartnerContact(Deger);
            }
            setLoading(false);
          })
          .catch(error => {
            setServicePartnerContact([]);
            setLoading(false);
          });
      
    
  }
  useEffect(() => {
    GetServiceShopByTenant();
   
  }, [dispatch]);

  // useEffect(() => {
  //   setStatusLogicData(JobOrderLogicStatus);
  //   setStatusId(jobOrderStatus[0]);
  //   setReasonData(rejectReason);
  //   setIssueList(issueListSelector.filter((x) => x?.IssueTypeId !== 1));
  //   setCaseStatusList(caseStatusListSelector);
  // }, [serviceShopControl, jobOrderStatus, rejectReason, JobOrderLogicStatus, issueListSelector]);

  useEffect(() => {
    setinitialRows(ServicePartnerContact);
  }, [ServicePartnerContact]);

  async function changeRegion(region) {
    setRegionSelected(region);
    //dispatch(getServiceShopForRegion(region.RegionId));
  }

  

  

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };


  const requestSearch = (searchedVal) => {
    const filteredRows = ServicePartnerContact.filter((item) => sc(
      item.SourceServiceShopCode + item.Dsc + item.ServiceShopPhone + item.Email 
      ,
      searchedVal
    ));
    setinitialRows(filteredRows);
  };

  
  // const handleSaveIssue = (ids) => {
  //   const dict = {
  //     Ids: ids,
  //     StatusId: changeStatus.Id,
  //     RejectDescription: rejectDescription,
  //     EmployeeId: SessionUser.TechnicianId,
  //     Status: changeStatus.FieldText
  //   };
  //   setChangeStatus('')
  //   dispatch(setTaskStatusByIssue(dict));
  //   searchWorkOrder();
  //   setRejectDescription();
  //   setCheckedWorkCaseId([]);
  //   setSnackbarOpen(true);
  //   setresponseMessage({
  //     ErrorCode: 10,
  //     ErrorDescription: t('lblSuccessfulOperation')
  //   });
  //   setUyariTip('success');


  // };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };


  // const SetOpenSinglePage = (row) => {
  //   setWorkCaseFeedBacks([])
  //   dispatch(getWorkCaseFeedbacks(row.WorkCaseId)).then(response => {
  //     setWorkCaseFeedBacks(response.payload)
  //   })
  //   setRequired(false);
  //   setSingleWorkOrderId(row.WorkCaseId);
  //   setSelectedIndex(row.ReceiptNo);
  //   setRejectDescription('')
  //   setSinglePopUp(true);
  //   setChangeStatus([]);
  // }

  // const SetPopupAcceptRejectPage = () => {
  //   setWorkCaseFeedBacks([])
  //   dispatch(getWorkCaseFeedbacks(initialRows[0]?.WorkCaseId)).then(response => {
  //     setWorkCaseFeedBacks(response.payload)
  //   })
  //   setRejectDescription('')
  //   setRequired(false);
  //   setPopUp(true);
  //   setChangeStatus([]);
  // }


  

  return (
    <>
      <Page title="">
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Container maxWidth="xl" spacing={1} className={classes.root}>
        <Breadcrumbs >
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('lblServicePartnerContact')}</Typography>
        </Breadcrumbs>
          <Card>
           
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={2} lg={8}>
                </Grid>
                <Grid item xs={12} sm={2} lg={4}>
                  <SearchBar
                    value={searched}
                    onChange={searchVal => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    placeholder={t('lblSearch')}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
              </Grid>
              <br />
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" />
                      <TableCell align="left">{t('SapCode')}</TableCell>
                      <TableCell align="left">{t('Name')}</TableCell>
                      <TableCell align="left">{t('Phone Number')}</TableCell>
                      <TableCell align="left">{t('Email')}</TableCell>
                      <TableCell align="left" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {initialRows.map((row, index) => (
                      <TableRow key={index}  >
                        <TableCell>
                          {/* <FormControlLabel
                            value="top"
                            control={(
                              <Checkbox
                                color="primary"
                                checked={checkedWorkCaseId.includes(row.WorkCaseId) ? true : false}
                                onChange={() => {
                                  setSelectedIndex(row.ReceiptNo)
                                  if (checkedWorkCaseId.includes(row.WorkCaseId)) {
                                    setCheckedWorkCaseId(checkedWorkCaseId.filter((item) => item !== row.WorkCaseId));
                                  } else {
                                    setCheckedWorkCaseId([...checkedWorkCaseId, row.WorkCaseId]);
                                  }
                                }}
                              />
                            )}
                          /> */}

                        </TableCell>
                        <TableCell align="left">{row.SourceServiceShopCode}</TableCell>
                        <TableCell align="left">{row.Dsc}</TableCell>
                        <TableCell align="left">{row.ServiceShopPhone}</TableCell>
                        <TableCell align="left">{row.Email}</TableCell>
                       
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            <DialogActions>
              <Grid item xs={12} sm={2} lg={2}>
                {/* <Tooltip title="Act on selected checkboxes">
                  <Button
                    disabled={checkedWorkCaseId.length === 0}
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    onClick={() => SetPopupAcceptRejectPage()}
                    endIcon={<EditIcon />}
                  >
                    {t('lblOperation')}
                  </Button>
                </Tooltip> */}
              </Grid>
            </DialogActions>
          </Card>
        </Container>
       
       

        <Snackbar open={SnackbarOpen} autoHideDuration={10000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
      </Page>
    </>
  );
}
ServicePartnerContact.propTypes = {
  className: PropTypes.string
};
export default ServicePartnerContact;
